import { PageMeta } from "@/components/common/Seo/PageMeta"
import DataPartnershipPage from "@/components/getListed/chainListing/DataPartnershipPage"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "Get your chain listed",
        description:
          "List your L1, L2 or appchain on Token Terminal. We run nodes for your chain and serve its raw, decoded and standardized data on all our products. Apply today.",
      }}
    />
    <DataPartnershipPage />
  </>
)

export default index
